import React from 'react';
import t from '../../i18n/I18n';
import Modal2 from '../../modals/Modal2';
import { extDetailsType } from './BrowseExtParent';
import './InfoModal.css';
type infoModalProps = {
  extDetails: extDetailsType,
  onClose: Function
};

function InfoModal(props: infoModalProps) {
  const { onClose, extDetails } = props;
  const modalProps = {
    name: 'BrowseExtInfoModal',
    title: t('DETAILS'),
    onClose: onClose,
    buttons: [{ label: t('CLOSE'), onClick: onClose, type: 'CANCEL' }]
  };
  return (
    <Modal2 {...modalProps}>
      <div className="container flex-row">
        <div className="content flex-col">
          <div>{t('SIZE')}</div>
          <div>{t('LAST_MODIFIED')}</div>
        </div>
        <div className="content flex-col">
          <div>{extDetails.node.getSizeInKB()}</div> 
          <div>{extDetails.node.getLastModifiedAsString()}</div> 
        </div>
      </div>
    </Modal2>
  );
}

export default InfoModal;
